import { memo, useEffect, useState } from 'react';
import ProjFn from '@/utils/fn';
import classnames from 'classnames';
import { subscribeLoginChannelReady } from '../utils/loginChannelEvent';

const BOX_AGREEMENT_URLS = {
  userAgreement: 'https://land.996box.com/user-agreement.html',
  privacyPolicy: 'https://land.996box.com/Privacy-policy.html',
  childPrivacyPolicy: 'https://land.996box.com/agreement/appPrivacyGuide.html'
};

const RJ_AGREEMENT_URLS = {
  userAgreement: 'https://rxbox.hadzkj.com/agreement/appUserAgreement.html',
  privacyPolicy: 'https://rxbox.hadzkj.com/agreement/appPolicy.html',
  childPrivacyPolicy: 'https://rxbox.hadzkj.com/agreement/appPrivacyGuide.html'
};
interface HeadBtnProps {
  agreementType: number;
  clause?: boolean;
  setClause?: (val: boolean) => void;
}

function LoginFooter(props: HeadBtnProps) {
  const { agreementType, clause } = props;
  const [agreementUrls, setAgreementUrls] = useState(BOX_AGREEMENT_URLS);

  useEffect(() => {
    return subscribeLoginChannelReady(state => {
      setAgreementUrls(state.isRJ ? RJ_AGREEMENT_URLS : BOX_AGREEMENT_URLS);
    });
  }, []);

  function openWeb(url: string) {
    ProjFn.openExternalBrower(url);
  }

  const getCheckState = (val: boolean) => {
    props?.setClause && props?.setClause(val);
  };

  const handleCheckboxChange = (e: any) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    const isChecked = e.target.checked;
    getCheckState(isChecked);
  };

  const footerBtn =
    agreementType === 1 ? (
      <span className="checkbox_text">登录即同意</span>
    ) : agreementType === 2 ? (
      <span className="checkbox_text">
        <input
          type="checkbox"
          className="login-clauseCheckbox login-clauseCheckboxTwo"
          checked={clause}
          onChange={handleCheckboxChange}
        />
        已仔细阅读并同意
      </span>
    ) : (
      <span className="checkbox_text">请勾选并同意</span>
    );

  const {
    userAgreement: userAgreementUrl,
    privacyPolicy: privacyPolicyUrl,
    childPrivacyPolicy: childPrivacyPolicyUrl
  } = agreementUrls;
  return (
    <div className={classnames('loginClauseFooterBox', `${'loginClauseFooterTypeBox' + agreementType}`)}>
      {footerBtn}
      <span className="checkbox_yellow">
        <span onClick={() => openWeb(userAgreementUrl)}>《用户注册协议》</span>
        <span onClick={() => openWeb(privacyPolicyUrl)}>《隐私条款》</span>
        <span onClick={() => openWeb(childPrivacyPolicyUrl)}>《儿童隐私保护协议》</span>
      </span>
    </div>
  );
}
export default memo(LoginFooter);
